import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SearchIcon, SmartphoneIcon, HourglassIcon } from 'lucide-react';
export function WhyFails() {
  return <section className="bg-white py-20 px-6" data-id="element-392">
      <div className="max-w-4xl mx-auto" data-id="element-393">
        <FadeIn data-id="element-394">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2A4A] mb-12 text-center" data-id="element-395">
            Por qué lo que has intentado falla
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-396">
          <FadeIn delay={100} data-id="element-397">
            <div className="bg-[#FDF8F3] p-8 rounded-2xl h-full border border-transparent hover:border-[#3BBFAD]/30 transition-colors" data-id="element-398">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm text-[#3BBFAD]" data-id="element-399">
                <SearchIcon className="w-6 h-6" data-id="element-400" />
              </div>
              <h3 className="font-serif text-xl text-[#1B2A4A] mb-4" data-id="element-401">
                1) Google te da volumen, no prioridad
              </h3>
              <p className="text-[#1B2A4A]/70" data-id="element-402">
                Te enseña 50 “señales” como si todas pesaran igual. No pesan
                igual.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-403">
            <div className="bg-[#FDF8F3] p-8 rounded-2xl h-full border border-transparent hover:border-[#3BBFAD]/30 transition-colors" data-id="element-404">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm text-[#3BBFAD]" data-id="element-405">
                <SmartphoneIcon className="w-6 h-6" data-id="element-406" />
              </div>
              <h3 className="font-serif text-xl text-[#1B2A4A] mb-4" data-id="element-407">
                2) Los videos te dan emociones, no decisiones
              </h3>
              <p className="text-[#1B2A4A]/70" data-id="element-408">
                Te dejan pensando “esto se parece” o “esto no se parece”… pero
                no te dan un plan.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={300} data-id="element-409">
            <div className="bg-[#FDF8F3] p-8 rounded-2xl h-full border border-transparent hover:border-[#3BBFAD]/30 transition-colors" data-id="element-410">
              <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center mb-6 shadow-sm text-[#3BBFAD]" data-id="element-411">
                <HourglassIcon className="w-6 h-6" data-id="element-412" />
              </div>
              <h3 className="font-serif text-xl text-[#1B2A4A] mb-4" data-id="element-413">
                3) “Espera y verás” calma a otros, no a ti
              </h3>
              <p className="text-[#1B2A4A]/70" data-id="element-414">
                Porque tú no quieres una opinión. Quieres una estructura.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}